// extracted by mini-css-extract-plugin
module.exports = {"var-in-mobile":"max-width: 767.98px","varInMobile":"max-width: 767.98px","container":"container--45d79","tripleBtn":"tripleBtn--fd7c5"};